module.exports = __webpack_public_path__ + "media/images/icon-arrow-ur-large@3x-0864a264218a57047dbe271d86b9de92.png";